import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontMerriweather, fontRobotoCondensed, theme } from "shared/lib/styles";

import { PlusWidgetTheme } from ".";
import BackgroundPlusWidget from "./plus-widget-background.png";
import SvgPlusWidgetPlaceholderTablet from "./plus-widget-placeholder-tablet.svg";
import SvgPlusWidgetPlaceholder from "./plus-widget-placeholder.svg";

export const PlusWidgetLightThemeStyle = {
  Container: css`
    display: flex;
    flex-direction: column;
    gap: 4px;
  `,
  Headline: css`
    color: #000000;
    font-weight: 700;
    font-size: 15px;
    font-family: ${fontMerriweather};
    font-style: normal;
    line-height: 140%;
    &:hover {
      color: #2c4692;
      text-decoration: none;
    }
  `,
  Label: css`
    color: #4585ff;
    font-weight: 700;
    font-size: 13px;
    font-family: ${fontRobotoCondensed};
    line-height: normal;
  `,
  LabelContainer: css`
    display: flex;
    gap: 8px;
    align-items: center;
  `,
  SeparatorEnd: css`
    margin-block-end: 16px;
    padding-block-end: 16px;
    border-block-end: 1px solid rgba(0, 0, 0, 0.1);
  `,
  SeparatorStart: css`
    margin-block-start: 16px;
    padding-block-start: 16px;
    border-block-start: 1px solid rgba(0, 0, 0, 0.1);
  `,
};

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const ContentWrapper = styled.div`
  max-inline-size: 360px;
  margin-inline: auto;
  ${theme.breakpoints.between("tablet", "desktop")} {
    max-inline-size: 656px;
  }
`;

export const PlusWidgetPlaceholder = styled(SvgPlusWidgetPlaceholder)`
  display: block;
  ${theme.breakpoints.between("tablet", "desktop")} {
    display: none;
  }
`;

export const PlusWidgetPlaceholderTablet = styled(SvgPlusWidgetPlaceholderTablet)`
  display: none;
  ${theme.breakpoints.between("tablet", "desktop")} {
    display: block;
  }
`;

export const Placeholder = () => (
  <>
    <PlusWidgetPlaceholder />
    <PlusWidgetPlaceholderTablet />
  </>
);

type ContentContainerProps = {
  $plusWidgetTheme: PlusWidgetTheme;
};

export const ContentContainer = styled.div<ContentContainerProps>`
  inline-size: 100%;
  max-inline-size: 727px;
  margin-inline: auto;
  padding: 24px;

  color: #ffffff;

  border-radius: 12px;

  background-image: url(${BackgroundPlusWidget.src});
  background-position: top right;
  background-size: cover;

  ${theme.breakpoints.between("tablet", "desktop")} {
    max-inline-size: 960px;
    padding-inline: 24px;
  }

  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 300px;
  }

  ${props =>
    props.$plusWidgetTheme === PlusWidgetTheme.LIGHT &&
    css`
      padding-inline: 20px;

      color: #000000;

      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 8px;

      background: #ffffff;

      ${theme.breakpoints.between("tablet", "desktop")} {
        padding: 20px;
      }

      ${ContentWrapper} {
        max-inline-size: unset;
        margin: unset;
      }
    `}
`;
